import {ClientApp} from "../../entities/ClientApp";
import {ClientAppService} from "../../services/ClientAppService";
import {NotificationService} from "../../services/NotificationService";
import { GrantTypes } from "../../libs/GrantTypes";
import { ClientAppSettings } from "../../libs/ClientAppSettings";

export class EditClientAppCtrl {
    $scope: any;
    originalClientId: string;
    originalSecret: string;
    entity: ClientApp;
    
    modalInstance:angular.ui.bootstrap.IModalServiceInstance;
    public static $inject = ['$scope','$uibModalInstance', 'ClientAppService', 'NotificationService', 'clientApp'];
    constructor($scope:any, $modalInstance:angular.ui.bootstrap.IModalServiceInstance, public clientAppService:ClientAppService, public notifyService:NotificationService, clientApp:ClientApp) {
        this.$scope = $scope;
        this.entity = clientApp;
        this.originalClientId = clientApp.clientID;
        this.originalSecret = clientApp.secret;
        this.modalInstance = $modalInstance;
        $scope.vm = this;
        if(clientApp.id == null){
            this.clientAppService.generateSecret().then((secret)=>{
                clientApp.secret = secret;
            })
        }
    }
    newSecret() {
        this.clientAppService.generateSecret().then((secret) => {
            this.entity.secret = secret;
        })
    }
    ok() {

        if (!this.entity.clientID.match(/^[0-9a-z]+$/i)) {
            this.notifyService.notifyError(("Client Name must be alpha numeric with no spaces."));
            return;
        }
        if(this.entity.clientID == null || this.entity.clientID.length == 0){
            this.notifyService.notifyError(("Client ID is required"));
            return;
        }
        if(this.entity.grantType == null || this.entity.grantType.length == 0){
            this.notifyService.notifyError(("Grant Type is required"));
            return;
        }
        if (this.entity.grantType === GrantTypes.CLIENTCREDENTIALS && (this.entity.secret == null || this.entity.secret.length==0)){
            this.notifyService.notifyError(("Secret is required for Client Credentials grant type."));
            return;
        }
        if (this.originalClientId == ClientAppSettings.ALARMNOTIFIERCLIENTID) {
            this.entity.clientID = this.originalClientId; //don't let them change the ams client id
            this.entity.grantType = GrantTypes.CLIENTCREDENTIALS;
        }
        if (this.originalClientId == ClientAppSettings.RADSCLIENTID) {
            this.entity.clientID = this.originalClientId; //don't let them change the ams client id
            this.entity.grantType = GrantTypes.CLIENTCREDENTIALS;
        }
        if (this.originalClientId == ClientAppSettings.AMSCLIENTID) {
            this.entity.clientID = this.originalClientId; //don't let them change the ams client id
            this.entity.grantType = GrantTypes.CLIENTCREDENTIALS;
        }
        if (this.originalClientId == ClientAppSettings.ASSETWORXMOBILECLIENTID) {
            this.entity.clientID = this.originalClientId; //don't let them change the ams assetworx mobile client id
            this.entity.secret = ClientAppSettings.ASSETWORXMOBILECLIENTSECRET;
            this.entity.allowRefreshTokens = true;
            this.entity.grantType = GrantTypes.AUTHORIZATIONCODE;
        }
        //allowRefreshTokens
        this.modalInstance.close(true);
    }

    cancel() {
        this.modalInstance.dismiss('cancel');
    }
}
